import React from "react";
import DotsComponent from "./DotsComponent";
import ProgressBar from "./ProgressBar";
// import ProgressBar from 'react-bootstrap/ProgressBar';
// import 'bootstrap/dist/css/bootstrap.min.css';

const AccScaleRender = (props) => {
  return (
    <div className="scale">
    <DotsComponent/>
      <h4 className="scale-head">{props.data.dataheading}</h4>
      <div className="scale-text">
        <p>{props.data.description}</p>
        <hr style={{ color: "#7E7E7E" }} />
        <p>{props.data.bills}</p>
      </div>
      <div className="scale-bar">
        <ProgressBar />
      </div>
      <div className="progressbar-details">
        <div>
          <p className="scale-open">Open:</p>
          <p className="scale-open-m">{props.data.openbill}</p>
        </div>
        <div>
          <p className="scale-overdue">Overdue:</p>
          <p className="scale-overdue-m">{props.data.overduebill}</p>
        </div>
      </div>
      <div className="scale-view">
        <a >{props.data.details}</a>
      </div>
    </div>
  );
};

export default AccScaleRender;
